import { Tagline } from "@/ui/Tagline";
import cn from "classnames";
import { chunk } from "lodash/array";
import { Col, Container, ListGroup, Row } from "react-bootstrap";

import classes from "./styles.module.scss";

export default function ({
  className = "py-5 py-md-6",
  tagline,
  title,
  description,
  items,
  lg = 3,
  EditableText,
  EditableHtml,
  theme = "light",
}) {
  return (
    <div className={cn(className, classes.ContentListHorizontal)} data-bs-theme={theme}>
      <Container fluid="md">
        <Tagline as={EditableText} path="tagline" tag="strong" className="d-block mb-3">
          <span dangerouslySetInnerHTML={{ __html: tagline }} />
        </Tagline>
        <EditableText path="title" tag="h2">
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </EditableText>
        <EditableHtml path="description">
          <div dangerouslySetInnerHTML={{ __html: description }} />
        </EditableHtml>
        <Row>
          {chunk(items, 2).map((arr, idx) => (
            <Col key={idx} className="flex-grow-1" xs={12} sm={6} lg={lg}>
              <ListGroup>
                {arr.map((item, index) => (
                  <ListGroup.Item key={index} as={EditableText} path={`item_${index}.${idx}`}>
                    {item}
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
